var _require = require('../shared-constants'),
  VALID = _require.VALID,
  INVALID = _require.INVALID,
  NOT_SURE = _require.NOT_SURE;
module.exports = {
  VALID: VALID,
  INVALID: INVALID,
  NOT_SURE: NOT_SURE
};